import React from "react";

export const CareTeamIcon: React.FC = () => {
  return (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 40 40"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <desc>Created with sketchtool.</desc>
      <defs>
        <path
          d="M12,0 L12,0 C18.627417,-1.21743675e-15 24,5.372583 24,12 L24,12 C24,18.627417 18.627417,24 12,24 L12,24 C5.372583,24 8.11624501e-16,18.627417 0,12 L0,12 C-8.11624501e-16,5.372583 5.372583,1.21743675e-15 12,0 Z"
          id="path-1"
        ></path>
        <filter
          x="-54.2%"
          y="-45.8%"
          width="208.3%"
          height="208.3%"
          filterUnits="objectBoundingBox"
          id="filter-2"
        >
          <feOffset
            dx="0"
            dy="2"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feGaussianBlur
            stdDeviation="4"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="CareGEM-Provider-Global-navigation-V2.3"
          transform="translate(-13.000000, -144.000000)"
        >
          <g
            id="Symptoms-menu-Copy-2"
            transform="translate(14.000000, 143.000000)"
          >
            <g id="Care-Team-icon" transform="translate(7.000000, 7.000000)">
              <g id="Rectangle-Copy-205">
                <use
                  fill="black"
                  fillOpacity="1"
                  filter="url(#filter-2)"
                  xlinkHref="#path-1"
                ></use>
                <use
                  fill="#208CFF"
                  fillRule="evenodd"
                  xlinkHref="#path-1"
                ></use>
              </g>
              <path
                d="M10.5263158,12.894278 C11.1105448,12.894278 11.7618067,12.9852631 12.480121,13.1672361 C13.2846331,13.3683641 13.935895,13.6365307 14.4339263,13.9717441 C15.0277328,14.3740001 15.3246316,14.8193483 15.3246316,15.3078021 L15.3246316,17.1035789 L5.728,17.1035789 L5.728,15.3078021 C5.728,14.8193483 6.02489881,14.3740001 6.61870533,13.9717441 C7.1167366,13.6365307 7.7679985,13.3683641 8.57251056,13.1672361 C9.2908249,12.9852631 9.94208679,12.894278 10.5263158,12.894278 Z M10.5263158,7.50694737 C10.9573044,7.50694737 11.3547657,7.6146929 11.7187116,7.8301872 C12.0826576,8.04568151 12.3723733,8.34018597 12.5878676,8.71370942 C12.8033619,9.08723288 12.9111075,9.48948288 12.9111075,9.92047148 C12.9111075,10.3514601 12.8033619,10.7489214 12.5878676,11.1128673 C12.3723733,11.4768132 12.0826576,11.766529 11.7187116,11.9820233 C11.3547657,12.1975176 10.9573044,12.3052632 10.5263158,12.3052632 C10.0953272,12.3052632 9.69786588,12.1975176 9.33391995,11.9820233 C8.96997402,11.766529 8.68025825,11.4768132 8.46476395,11.1128673 C8.24926964,10.7489214 8.14152411,10.3514601 8.14152411,9.92047148 C8.14152411,9.48948288 8.24926964,9.08723288 8.46476395,8.71370942 C8.68025825,8.34018597 8.96997402,8.04568151 9.33391995,7.8301872 C9.69786588,7.6146929 10.0953272,7.50694737 10.5263158,7.50694737 Z M10.5263158,14.0435752 C9.98039689,14.0435752 9.40096535,14.1249829 8.78800378,14.2878008 C8.26123993,14.4314637 7.81110303,14.6038565 7.43757958,14.8049846 C7.06405612,15.0061126 6.8772972,15.1737167 6.8772972,15.3078021 L6.8772972,15.9542818 L14.1753344,15.9542818 L14.1753344,15.3078021 C14.1753344,15.1737167 13.9885755,15.0061126 13.615052,14.8049846 C13.2415285,14.6038565 12.7913916,14.4314637 12.2646278,14.2878008 C11.6516662,14.1249829 11.0722347,14.0435752 10.5263158,14.0435752 Z M10.5263158,8.65624456 C10.1719474,8.65624456 9.87265423,8.77835617 9.62842736,9.02258304 C9.38420048,9.26680992 9.26208887,9.56610307 9.26208887,9.92047148 C9.26208887,10.2748399 9.38420048,10.5693443 9.62842736,10.8039937 C9.87265423,11.038643 10.1719474,11.155966 10.5263158,11.155966 C10.8806842,11.155966 11.1799773,11.038643 11.4242042,10.8039937 C11.6684311,10.5693443 11.7905427,10.2748399 11.7905427,9.92047148 C11.7905427,9.56610307 11.6684311,9.26680992 11.4242042,9.02258304 C11.1799773,8.77835617 10.8806842,8.65624456 10.5263158,8.65624456 Z"
                id=""
                stroke="#FFFFFF"
                strokeWidth="0.2"
                fill="#FFFFFF"
              ></path>
              <rect
                id="Rectangle"
                fill="#FFFFFF"
                x="16.0526316"
                y="8.47368421"
                width="1.47368421"
                height="4.42105263"
              ></rect>
              <rect
                id="Rectangle-Copy"
                fill="#FFFFFF"
                x="14.5789474"
                y="9.94736842"
                width="4.42105263"
                height="1.47368421"
              ></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
